import { PaymentMethodValue, VatTypeValue } from "#src/services/payment/enum";
import { IPricingInfo } from "#src/services/payment/types";
import { Dispatch, SetStateAction } from "react";
import { PaymentEnterInformationCheckYourCart } from "./CheckYourCart";
import { PaymentEnterInformationCustomerInfo } from "./CustomerInfo";
import { PaymentEnterInformationOrderSummary } from "./OrderSummary";
import { PaymentEnterInformationPaymentMethod } from "./PaymentMethod";
import { PaymentEnterInformationVatInvoice } from "./VatInvoice";
import { ICustomerInfoRenderProps } from "./CustomerInfo/types";
import { IVatInvoiceRenderProps } from "./VatInvoice/types";

interface IPaymentEnterInformationProps {
  calculatedPricing: IPricingInfo;
  customerInfoRenderProps: ICustomerInfoRenderProps;
  invoiceType: VatTypeValue;
  vatInvoiceFieldRenderProps: IVatInvoiceRenderProps;
  paymentMethod: PaymentMethodValue;
  setPaymentMethod: Dispatch<SetStateAction<PaymentMethodValue>>;
  exportVatInvoice: boolean;
  setExportVatInvoice: Dispatch<SetStateAction<boolean>>;
  onApplyPromocode: (value: string) => Promise<boolean>;
  onRemovePromocode: (removeId: string) => void;
}

export const PaymentEnterInformation = ({
  calculatedPricing,
  customerInfoRenderProps,
  invoiceType,
  vatInvoiceFieldRenderProps,
  paymentMethod,
  setPaymentMethod,
  exportVatInvoice,
  setExportVatInvoice,
  onApplyPromocode,
  onRemovePromocode,
}: IPaymentEnterInformationProps) => {
  // --------------- RENDER ---------------

  return (
    <div className="flex flex-col gap-5">
      <PaymentEnterInformationCheckYourCart
        calculatedPricing={calculatedPricing}
      />
      <div className="grid grid-cols-3 gap-5">
        <div className="flex flex-col gap-5 col-span-2">
          <PaymentEnterInformationCustomerInfo
            customerInfoRenderProps={customerInfoRenderProps}
          />
          <PaymentEnterInformationPaymentMethod
            paymentMethod={paymentMethod}
            setPaymentMethod={setPaymentMethod}
          />
          <hr className="border-t border-gray-v2-200" />
          <PaymentEnterInformationVatInvoice
            exportVatInvoice={exportVatInvoice}
            setExportVatInvoice={setExportVatInvoice}
            invoiceType={invoiceType}
            vatInvoiceFieldRenderProps={vatInvoiceFieldRenderProps}
          />
        </div>
        <PaymentEnterInformationOrderSummary
          calculatedPricing={calculatedPricing}
          onApplyPromocode={onApplyPromocode}
          onRemovePromocode={onRemovePromocode}
        />
      </div>
    </div>
  );
};
